<div class="text-bg-highlight text-xlarge mb-3">"{{ignorering.name}}"</div>
<form [formGroup]="form">
    <div class="d-flex flex-column mb-3">
        <label for="standardnamn">Ändra som synonym till</label>
        <p-select id="standardnamn" formControlName="selectedStandardNamn" styleClass="w-100" [options]="standardNamnList" optionLabel="name" optionValue="name" placeholder="Välj">
        </p-select>
    </div>
    <div class="d-flex flex-column mb-3">
        <label for="comment">Kommentar</label>
        <textarea id="comment" formControlName="comment" type="text" rows="3" pInputTextarea></textarea>
    </div>
</form>
<div class="d-flex mt-4">
    <button type="button" class="btn btn-secondary flex-grow-1" [style.marginRight]="'20px'" (click)="close()">Avbryt</button>
    <button type="button" class="btn btn-primary flex-grow-1" (click)="save()" [disabled]="form.pristine || !form.valid">Spara</button>
</div>
